<template>
	<div class="comment-chat">
		<div class="comment-chat__head">
			<div class="comment-chat__title">
				{{ title }}
			</div>

			<div class="comment-chat__head-action" @click="closeChat">
				<svg
					width="20"
					height="20"
					x="0"
					y="0"
					class="stencil--easier-to-select"
					style="opacity: 1;"
				>
					<defs></defs>
					<rect
						x="0"
						y="0"
						width="20"
						height="20"
						fill="transparent"
						class="stencil__selection-helper"
					></rect>
					<path
						d="M20 2.014285714285715C20 2.014285714285715 17.985714285714288 0 17.985714285714288 0 17.985714285714288 0 10 7.985714285714285 10 7.985714285714285 10 7.985714285714285 2.014285714285715 0 2.014285714285715 0 2.014285714285715 0 0 2.014285714285715 0 2.014285714285715 0 2.014285714285715 7.985714285714285 10 7.985714285714285 10 7.985714285714285 10 0 17.985714285714288 0 17.985714285714288 0 17.985714285714288 2.014285714285715 20 2.014285714285715 20 2.014285714285715 20 10 12.014285714285716 10 12.014285714285716 10 12.014285714285716 17.985714285714288 20 17.985714285714288 20 17.985714285714288 20 20 17.985714285714288 20 17.985714285714288 20 17.985714285714288 12.014285714285716 10 12.014285714285716 10 12.014285714285716 10 20 2.014285714285715 20 2.014285714285715"
						stroke-width="0"
						stroke="none"
						stroke-dasharray="none"
						fill="rgb(98, 98, 98)"
						fill-rule="evenOdd"
					></path>
				</svg>
			</div>
		</div>

		<div class="comment-chat__list">
			<VuePerfectScrollbar
				ref="verticalNavMenuPs"
				:key="$vs.rtl"
				:settings="settings"
				class="comments"
				@ps-scroll-y="psSectionScroll"
				@scroll="psSectionScroll"
			>
				<div
					v-for="(comment, idx) in comments"
					:key="idx"
					class="comments__item"
				>
					{{ comment }}
				</div>

				<div ref="endOfComments"></div>
			</VuePerfectScrollbar>
		</div>

		<div class="comment-chat__actions">
			<div class="comment-chat__actions-input">
				<vs-input
					v-model="comment"
					:disabled="loading"
					:placeholder="`${$t('comment')}...`"
				/>
			</div>

			<div class="comment-chat__actions-button">
				<vs-button
					color="primary"
					class="flex-grow"
					type="filled"
					:disabled="loading || !comment"
					@click="addComment"
				>
					{{ $t("send") }}
				</vs-button>
			</div>
		</div>
	</div>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";
import notifier from '@/mixins/notifier';
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
	name: "AffairItemCommentChat",

	mixins: [databaseManager, notifier],

	components: {
		VuePerfectScrollbar
	},

	props: {
		groupItem: {
			type: Object,
			default: null
		}
	},

	data() {
		return {
			comments: [],
			comment: "",
			loading: false,
			settings: {
				maxScrollbarLength: 100,
				wheelSpeed: 0.1,
				swipeEasing: true
			},
			showShadowBottom: false
		};
	},

	computed: {
		groupId() {
			return this.groupItem ? this.groupItem.group_id : null;
		},

		title() {
			return this.groupItem ? this.groupItem.description : "";
		}
	},

	async mounted() {
		await this.loadCommentsList();
		this.scrollToBottom();
	},

	methods: {
		psSectionScroll() {
			const scroll_el =
				this.$refs.verticalNavMenuPs.$el ||
				this.$refs.verticalNavMenuPs;
			this.showShadowBottom = scroll_el.scrollTop > 0;
		},

		async loadCommentsList() {
			try {
				if (!this.groupId) {
					return;
				}

				this.loading = true;
				const res = await this.dbGetTaskComments(this.groupId);
				this.comments = res;
			} catch (err) {
        this.notifyError(err.message)
			} finally {
				this.loading = false;
			}
		},

		closeChat() {
			this.$emit("closeChat");
		},

		async addComment() {
			try {
				if (!this.groupId) {
          this.notifyError('Group id is not defined')
					return;
				}

				this.loading = true;

				await this.dbAddTaskComment({
					id: this.groupId,
					comment: this.comment
				});

				await this.loadCommentsList();
        this.scrollToBottom()

				this.comment = "";
			} catch (err) {
        this.notifyError(err.message)
			} finally {
				this.loading = false;
			}
		},

		scrollToBottom(isImportant = true) {
			this.$nextTick(() => {
				if (isImportant !== true) return;

				const endOfComments = this.$refs.endOfComments

				if (endOfComments !== null) {
					endOfComments.scrollIntoView(false);
				} else {
					this.$refs.verticalNavMenuPs.$el.scrollTop = 1000000;
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
@import "affair-item-comment-chat";
</style>
